import { Injectable, signal } from '@angular/core'
import { ContactFormValue } from '@features/platforme/dashboard/components'

export interface ContactFormModalConfig {
  onSubmit: (value: ContactFormValue) => void
  onCancel?: () => void
}

@Injectable({ providedIn: 'root' })
export class ContactFormModalService {
  readonly config = signal<ContactFormModalConfig | null>(null)

  open(config: ContactFormModalConfig): void {
    this.config.set(config)
  }

  close(): void {
    this.config.set(null)
  }
}
